export default __webpack_public_path__ + "static/media/imperial.277b624a.svg";